import React, { useState } from 'react';
import {
  ContentCopy as CopyIcon,
  OpenInNew as OpenInNewIcon,
  Share as ShareIcon,
} from '@mui/icons-material';
import NotificationService from '../../services/NotificationService';

const PublicProfileSharePanel = ({ publicProfileUrl }) => {
  const [copyFeedback, setCopyFeedback] = useState(false);

  if (!publicProfileUrl) {
    return (
      <section className="border border-amber-200 bg-amber-50 rounded-lg p-4 mb-6">
        <h3 className="text-lg font-semibold text-gray-900">Partager ma fiche</h3>
        <p className="text-sm text-amber-800 mt-1">
          Votre adresse publique n’est pas encore disponible. Configurez d’abord le slug de votre
          boutique dans Apparence.
        </p>
      </section>
    );
  }

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(publicProfileUrl);
      setCopyFeedback(true);
      window.setTimeout(() => setCopyFeedback(false), 2000);
    } catch (error) {
      NotificationService.error("Impossible de copier l'adresse");
    }
  };

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: 'Ma fiche artisan sur Ritaaa',
          text: 'Découvrez mon univers sur Ritaaa',
          url: publicProfileUrl,
        });
        return;
      } catch (error) {
        if (error?.name === 'AbortError') {
          return;
        }
      }
    }
    await handleCopy();
  };

  return (
    <section className="border border-gray-200 rounded-lg p-4 mb-6">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <h3 className="text-lg font-semibold text-gray-900">Partager ma fiche</h3>
          <p className="text-sm text-gray-600 mt-1">
            Votre fiche artisan publique, prête à être partagée.
          </p>
          <code className="mt-2 inline-block text-sm text-blue-800 break-all">{publicProfileUrl}</code>
        </div>
        <div className="flex flex-wrap gap-2">
          <a
            href={publicProfileUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-3 py-2 text-sm border border-gray-300 rounded-md hover:bg-gray-50"
          >
            <OpenInNewIcon fontSize="small" className="mr-1" />
            Voir ma fiche
          </a>
          <button
            type="button"
            onClick={handleCopy}
            className="inline-flex items-center px-3 py-2 text-sm border border-gray-300 rounded-md hover:bg-gray-50"
          >
            <CopyIcon fontSize="small" className="mr-1" />
            {copyFeedback ? 'Copié !' : 'Copier le lien'}
          </button>
          <button
            type="button"
            onClick={handleShare}
            className="inline-flex items-center px-3 py-2 text-sm bg-blue-600 text-white rounded-md hover:bg-blue-700"
          >
            <ShareIcon fontSize="small" className="mr-1" />
            Partager
          </button>
        </div>
      </div>
    </section>
  );
};

export default PublicProfileSharePanel;
